import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "relative" }
const _hoisted_2 = {
  key: 0,
  class: "absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-white dark:bg-darkCardBg border z-50 rounded-md px-8 py-2"
}
const _hoisted_3 = { class: "text-lg mt-2 text-gray-600 dark:text-white/75" }
const _hoisted_4 = {
  ref: "chartContainer",
  class: "tv-chart-container h-[700px]"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_rb_exchange_icon = _resolveComponent("rb-exchange-icon")!
  const _component_skeleton = _resolveComponent("skeleton")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (_ctx.hardHideChart)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_rb_exchange_icon, {
            class: "w-28 mt-2",
            "exchange-id": _ctx.exchange
          }, null, 8, ["exchange-id"]),
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.refs.localization?.tv?.no_data || 'Нет данных'), 1)
        ]))
      : _createCommentVNode("", true),
    (!_ctx.init)
      ? (_openBlock(), _createBlock(_component_skeleton, { key: 1 }))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("div", _hoisted_4, null, 512), [
      [_vShow, _ctx.init]
    ])
  ]))
}